
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteE as ObiOwnShipRemoteEElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-e.js';
 
 
 

 
 export const ObiOwnShipRemoteE = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-e',
   elementClass: ObiOwnShipRemoteEElement,
   events: {
     
   }
  });
 
 